@if (!loading) {
  <div class="app">
    
    @if (profile) {
      <lib-header [show_settings]="[1,2,4].includes(profile.role_id)" [show_admin_entry]="true">
        <div>
          <div class="ollie" (click)="goToOllie()">
            <img src="assets/ollie-sparkle.svg" style="width: 35px;"/>
            <div>Ollie</div>
          </div>
        </div>
      </lib-header>
    }

    <div class="main" (scroll)="updateScroll($event)">
      <router-outlet></router-outlet>
    </div>
  </div>
}
<lib-consent-banner></lib-consent-banner>
